import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import Blog1 from "../images/blog-1.png";

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const createSlug = (title) =>
    title?.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await fetch("https://petcrew.in/app-admin/api/blog.php?type=home");
        const data = await response.json();
        if (data.Error === "False" && Array.isArray(data.Data)) {
          setBlogPosts(data.Data);
        } else {
          throw new Error(data.Message || "Unable to fetch blogs");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogPosts();
  }, []);

  if (loading) return <p>Loading blog posts...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!blogPosts.length) return <p>No blog posts available.</p>;

  const handleClick = (id, title) => {
    const slug = createSlug(title);
    navigate(`/blog-detail/${id}/${slug}`);
  };

  return (
    <div className="blog-section">
      <h2 className="blog-title">Heart of the Story & Hot Topics</h2>
      <Link to="/heart-of-the-story" className="blog-details">View All News & Stories</Link>
      <div className="blog-grid">
        {/* Main Article */}
        <div className="main-article" onClick={() => handleClick(blogPosts[0].id, blogPosts[0].title)} style={{ cursor: "pointer" }}>
          <img src={blogPosts[0].image_link || Blog1} alt={blogPosts[0].title} className="main-image" />
          <h3 className="main-title">{blogPosts[0].title}</h3>
          <p className="main-description">{blogPosts[0].desc}</p>
          <p className="main-date">{blogPosts[0].posted_on}</p>
        </div>

        {/* Sidebar Articles */}
        <div className="sidebar">
          {blogPosts.slice(1).map((post) => (
            <div
              key={post.id}
              className="sidebar-article"
              onClick={() => handleClick(post.id, post.title)}
              style={{ cursor: "pointer" }}
            >
              <div className="sidebar-text row">
                <div className="col-md-5">
                  <img src={post.image_link || Blog1} alt={post.title} className="slider-artical-image" />
                </div>
                <div className="col-md-7">
                  <h4 className="sidebar-title">{post.title}</h4>
                  <p className="sidebar-description">{post.desc}</p>
                  <p className="sidebar-date">{post.posted_on}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
